module.exports = __webpack_public_path__ + "static/media/logo.231ffcb1.svg";